/*
* <license header>
*/

module.exports = {
  extensionId: 'create-workfront-task'
}